(function () {
  function cfg() {
    // If you already defined these in theme.liquid, this will use them.
    const c = window.MINQTY_RULES || {};
    return {
      tag: String(c.tag || "amenidades50").toLowerCase().trim(),
      min: parseInt(c.min, 10) || 50,
      enable: c.enableProduct !== false
    };
  }

  function productHasTag(tags, tag) {
    if (!Array.isArray(tags)) return false;
    return tags.some(t => String(t).toLowerCase().trim() === tag);
  }

  function ensureInlineAlert(container) {
    // Put alert directly under the quantity-input container
    let el = container.querySelector("[data-minqty-inline-alert]");
    if (!el) {
      el = document.createElement("div");
      el.setAttribute("data-minqty-inline-alert", "1");
      el.style.cssText =
        "margin-top:8px;padding:10px 12px;border:1px solid #d22;border-radius:10px;background:#fff5f5;color:#8a0000;font-size:14px;line-height:1.35;display:none;";
      container.appendChild(el);
    }
    return el;
  }

  function setMinOnInput(input, minVal) {
    input.setAttribute("min", String(minVal));
    input.setAttribute("data-min", String(minVal)); // matches your markup pattern
    // Optional: also set step to 1 if you want strict integer
    if (!input.getAttribute("step")) input.setAttribute("step", "1");
  }

  function getQty(input) {
    const v = parseInt(input.value, 10);
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  function init() {
    const c = cfg();
    if (!c.enable || c.min <= 1) return;

    const root = document.querySelector("[data-minqty-product-root]");
    if (!root) return;

    let tags = [];
    try { tags = JSON.parse(root.getAttribute("data-product-tags-json") || "[]"); } catch (e) {}
    if (!productHasTag(tags, c.tag)) return;

    // Find your exact quantity input (Dawn style)
    const qtyWrap = document.querySelector(".price-per-item__container quantity-input.quantity")
      || document.querySelector("quantity-input.quantity")
      || document.querySelector("quantity-input");

    const qtyInput = (qtyWrap && qtyWrap.querySelector("input[name='quantity']"))
      || document.querySelector("input[name='quantity'][type='number']");

    if (!qtyInput) return;

    // Use the container you pasted: price-per-item__container (best place to append alert under quantity)
    const container = qtyInput.closest(".price-per-item__container") || qtyInput.parentElement;
    const alertEl = ensureInlineAlert(container);

    // Set min + initialize value to min if below
    setMinOnInput(qtyInput, c.min);
    if (getQty(qtyInput) < c.min) qtyInput.value = String(c.min);

    function showAlert(currentQty) {
      alertEl.textContent = `La cantidad minima de este producto son ${c.min}.`;
      alertEl.style.display = "block";
    }

    function hideAlert() {
      alertEl.style.display = "none";
    }

    // Validate whenever quantity changes
    function validate() {
      const q = getQty(qtyInput);

      if (q < c.min) {
        showAlert(q);
        // Keep user in control: don't force-jump while typing, but ensure add-to-cart won't pass (below)
        return false;
      }

      hideAlert();
      return true;
    }

    qtyInput.addEventListener("input", validate);
    qtyInput.addEventListener("change", validate);

    // If user clicks minus below min, many themes clamp due to min attribute,
    // but some UI scripts can still display lower temporarily; enforce on blur/change:
    qtyInput.addEventListener("blur", function () {
      const q = getQty(qtyInput);
      if (q < c.min) {
        qtyInput.value = String(c.min);
        showAlert(q);
      }
    });

    // Block add-to-cart submit if below min; allow normal flow if OK
    const form =
      qtyInput.closest("form[action^='/cart/add']") ||
      document.querySelector("form[action^='/cart/add']");

    if (form) {
      form.addEventListener("submit", function (e) {
        const ok = validate();
        if (!ok) {
          e.preventDefault();
          e.stopPropagation();
          // Optionally snap to min immediately on submit attempt:
          qtyInput.value = String(c.min);
          showAlert(getQty(qtyInput));
          qtyInput.focus();
        }
      });
    }

    // Run once
    validate();
  }

  document.addEventListener("DOMContentLoaded", init);
})();
